import { render, staticRenderFns } from "./DatabaseQuery.vue?vue&type=template&id=a938de8c&scoped=true"
import script from "./DatabaseQuery.vue?vue&type=script&lang=js"
export * from "./DatabaseQuery.vue?vue&type=script&lang=js"
import style0 from "./DatabaseQuery.vue?vue&type=style&index=0&id=a938de8c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a938de8c",
  null
  
)

export default component.exports